import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useContext } from 'react';

import AppContext from '@/contexts/appContext';
import SecretForm from '@/forms/SecretForm';
import { SecretFormValues } from '@/forms/SecretForm/types';
import SecretRepository from '@/repositories/SecretRepository';
import mapAxiosErrorMessages from '@/utils/mapAxiosErrorMessages';

import { Props } from './types';

const UpdateSecretForm = ({ initialValues, onSuccess, schema, secret }: Props) => {
  const { addMessage } = useContext(AppContext);
  const secretRepository = SecretRepository();
  const defaultValues = initialValues
    ? initialValues
    : {
        secretValue: secret?.value ?? ''
      };

  const updateSecret = useMutation({
    mutationFn: (values: { [key: string]: string }) => {
      return secretRepository.updateSecret({
        ...secret,
        value: Object.values(values)[0]
      });
    },
    onSuccess: async () => {
      addMessage({ level: 'success', text: 'Secret updated' });
      onSuccess?.();
    },
    onError: (error: AxiosError) => {
      addMessage(mapAxiosErrorMessages(error));
    }
  });

  const submitForm = (values: SecretFormValues) => {
    updateSecret.mutate(schema ? schema.cast(values) : values);
  };

  return (
    <SecretForm
      initialValues={defaultValues}
      isSubmitting={updateSecret.isPending}
      schema={schema}
      submitHandler={submitForm}
    />
  );
};

export default UpdateSecretForm;
